import { MarkerType } from 'reactflow';
import journeyStartIcon from 'img/journey_start.svg';
import actionIcon from 'img/ucd_actions_communications.svg';
import delayIcon from 'img/delay.svg';
import exitIcon from 'img/exit.svg';
import splitIcon from 'img/split.svg';
import dayjs from 'dayjs';

export const NODE_TYPES = {
  action: 'action',
  wait: 'wait',
  split: 'split',
  journeyStart: 'journeyStart',
  exit: 'exit',
};

export const SPLIT_FUNC_TEXT = {
  messageOpened: 'Opened message',
  promoRedeemed: 'Promo code redeem',
  martCompleted: 'Completed GrabMart Transaction',
};

export const BULK_ACTION_MAPPING = {
  push: 'bulkSendPush',
  inbox: 'bulkSendInbox',
  pushinbox: 'bulkPushChainedInbox',
  email: 'bulkSendEmail',
  sms: 'bulkSendSMS',
};

export const ACTION_TYPE_TEXT = {
  push: 'Push Notification',
  inbox: 'App Inbox',
  pushinbox: 'Push Chained Inbox',
  inApp: 'In-App',
  email: 'Email',
  sms: 'SMS',
  bulkSendPush: 'Push Notification',
  bulkSendInbox: 'App Inbox',
  bulkPushChainedInbox: 'Push Chained Inbox',
  bulkSendEmail: 'Email',
  bulkSendSMS: 'SMS',
};

export const TYPE_TO_FIELD_HEADER = {
  push: 'Title',
  inbox: 'Title',
  pushinbox: 'Title',
  inApp: 'Title',
  email: 'Subject',
  sms: 'Content',
};

export const TYPE_TO_PAYLOAD_FIELD = {
  push: 'title',
  inbox: 'title',
  pushinbox: 'push_title',
  inApp: 'title',
  email: 'subject',
};

export const MARKER_END_ARROW = {
  type: MarkerType.ArrowClosed,
  width: 20,
  height: 20,
  color: '#2D9F94',
};

export const TYPE_TITLE_MAPPING = {
  action: 'Action',
  wait: 'Delay',
  split: 'Decision Split',
  journeyStart: 'Trigger',
  exit: 'Exit',
};

export const NODETYPE_REQUIRED_FIELDS = {
  [NODE_TYPES.journeyStart]: ['userSource.sourceID', 'schedule.startTime'],
  [NODE_TYPES.action]: ['meta.messagingPayload.templateID'],
  [NODE_TYPES.split]: ['func', 'splits'],
};

export const SPLIT_CONDITIONS = {
  messageOpened: 'messageOpened',
  promoRedeemed: 'promoRedeemed',
  martCompleted: 'martCompleted',
};

export const PROMO_REDEEMED_IDENTIFIERS = {
  promoID: 'promoID',
  promoCode: 'promoCode',
};

export const TYPE_INFO_MAPPING = {
  action: { text: 'Communication', icon: actionIcon },
  wait: { text: 'Delay', icon: delayIcon },
  split: { text: 'Decision Split', icon: splitIcon },
  journeyStart: { text: 'Start Journey', icon: journeyStartIcon },
  exit: { text: 'Exit', icon: exitIcon },
};

export const DEFAULT_EDGES_STYLE = 'smoothstep';
export const DEFAULT_POSITION = { x: 0, y: 0 };

const JOURNEY_TEMPLATE_KEY_DATA = {
  reminder: {
    1: {
      type: 'journeyStart',
      data: {
        startType: 'schedule',
        schedule: {
          startTime: dayjs().add(30, 'minute'),
          endTime: dayjs().add(7, 'day'),
          frequency: 'da',
          interval: 1,
        },
        userSource: {
          sourceType: 'segment',
          sourceID: '',
        },
      },
      children: ['2'],
    },
    2: {
      type: 'action',
      data: {
        type: '',
        meta: {
          messagingPayload: {
            params: {
              en: {
                message: '',
                title: '',
              },
            },
            templateID: '',
            templateName: '',
          },
        },
      },
      children: ['3'],
    },
    3: {
      type: 'wait',
      data: {
        // type: 'untilRelativeTime',
        // relativeTime: {
        //   anchor: 'triggerTime',
        //   waitInMin: 1440,
        // },
        type: 'byDuration',
        duration: {
          waitInMin: 1440,
        },
      },
      children: ['4'],
    },
    4: {
      type: 'split',
      data: {
        func: 'messageOpened',
        param: {
          msgNodeID: '2',
        },
        splits: ['true', 'false'],
      },
      children: ['6', '5'],
    },
    5: {
      type: 'action',
      data: {
        type: '',
        meta: {
          messagingPayload: {
            params: {
              en: {
                message: '',
                title: '',
              },
            },
            templateID: '',
            templateName: '',
          },
        },
      },
      children: ['7'],
    },
    6: {
      type: 'exit',
      data: {},
    },
    7: {
      type: 'exit',
      data: {},
    },
  },
  adaptive: {
    1: {
      type: 'journeyStart',
      data: {
        startType: 'schedule',
        schedule: {
          startTime: dayjs().add(30, 'minute'),
          endTime: dayjs().add(7, 'day'),
          frequency: 'da',
          interval: 1,
        },
        userSource: {
          sourceType: 'segment',
          sourceID: '',
        },
      },
      children: ['2'],
    },
    2: {
      type: 'action',
      data: {
        type: '',
        meta: {
          messagingPayload: {
            params: {
              en: {
                message: '',
                title: '',
              },
            },
            templateID: '',
            templateName: '',
          },
        },
      },
      children: ['3'],
    },
    3: {
      type: 'wait',
      data: {
        // type: 'untilRelativeTime',
        // relativeTime: {
        //   anchor: 'triggerTime',
        //   waitInMin: 1440,
        // },
        type: 'byDuration',
        duration: {
          waitInMin: 1440,
        },
      },
      children: ['4'],
    },
    4: {
      type: 'split',
      data: {
        func: 'promoRedeemed',
        param: {
          msgNodeID: '2',
        },
        splits: ['true', 'false'],
      },
      children: ['7', '5'],
    },
    5: {
      type: 'split',
      data: {
        func: 'messageOpened',
        param: {
          msgNodeID: '2',
        },
        splits: ['true', 'false'],
      },
      children: ['8', '6'],
    },
    6: {
      type: 'action',
      data: {
        type: '',
        meta: {
          messagingPayload: {
            params: {
              en: {
                message: '',
                title: '',
              },
            },
            templateID: '',
            templateName: '',
          },
        },
      },
      children: ['9'],
    },
    7: {
      type: 'exit',
      data: {},
    },
    8: {
      type: 'exit',
      data: {},
    },
    9: {
      type: 'exit',
      data: {},
    },
  },
};

export default JOURNEY_TEMPLATE_KEY_DATA;
